import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "items-menu" }
const _hoisted_2 = { class: "commands-header" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "section-title"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_PulseSearch = _resolveComponent("PulseSearch")
  const _component_Empty = _resolveComponent("Empty")
  const _component_Command = _resolveComponent("Command")
  const _component_Collapse = _resolveComponent("Collapse")
  const _component_Divider = _resolveComponent("Divider")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    modelValue: $data.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.visible) = $event)),
    width: "42rem",
    class: "caps-menu",
    persistent: false,
    mask: "",
    "popper-class": "mobile-commands-popper",
    "outside-exceptions": ['.command-item-info']
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["reference", {disabled: $props.disabled, pointer: !$props.disabled}]),
        onClick: _cache[0] || (_cache[0] = $event => (!$props.disabled && ($data.visible = !$data.visible)))
      }, [
        ($data.visible)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              icon: "scroll-text",
              stroke: "var(--gray-500)",
              size: "1.6rem",
              "stroke-width": "1",
              hover: ""
            }))
          : (_openBlock(), _createBlock(_component_Tooltip, {
              key: 1,
              text: "Skills & Sources",
              teleported: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  hoverable: "",
                  icon: "scroll-text",
                  stroke: "var(--gray-500)",
                  size: "1.6rem",
                  "stroke-width": "1"
                })
              ]),
              _: 1 /* STABLE */
            }))
      ], 2 /* CLASS */)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Skills & Sources", -1 /* HOISTED */)),
          _createVNode(_component_Icon, {
            class: "pointer",
            icon: "x-close",
            size: "2rem",
            stroke: "var(--gray-500)",
            "stroke-width": "1",
            onClick: _withModifiers($options.close, ["stop"])
          }, null, 8 /* PROPS */, ["onClick"])
        ]),
        _createVNode(_component_PulseSearch, {
          modelValue: $data.search,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.search) = $event)),
          class: "commands-search",
          placeholder: "Search"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createVNode(_component_ScrollBar, {
          "max-height": "100%",
          class: "scrollbar",
          fade: "",
          "bar-x-offset": _ctx.$responsive.mobile ? '1rem' : undefined
        }, {
          default: _withCtx(() => [
            ($options.has_search && !$options.has_results)
              ? (_openBlock(), _createBlock(_component_Empty, {
                  key: 0,
                  bordered: false,
                  class: "empty",
                  "bg-size": "36rem",
                  "circle-size": "7.6rem"
                }, {
                  title: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("No skills or sources found")
                  ])),
                  "sub-text": _withCtx(() => [
                    _cache[6] || (_cache[6] = _createTextVNode(" There are no skills or sources matching your search.")),
                    _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                    _createElementVNode("a", {
                      class: "pointer",
                      onClick: _cache[2] || (_cache[2] = (...args) => ($options.clearSearch && $options.clearSearch(...args)))
                    }, "Clear search")
                  ]),
                  image: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      width: "4rem",
                      height: "4rem",
                      icon: "search",
                      stroke: "var(--brand-500)"
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : ($options.has_search)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filtered_skills, (skill) => {
                      return (_openBlock(), _createBlock(_component_Command, {
                        key: skill.command,
                        item: skill,
                        standalone: "",
                        onClick: $event => ($options.selectSkill(skill.command))
                      }, null, 8 /* PROPS */, ["item", "onClick"]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filtered_sources, (source) => {
                      return (_openBlock(), _createBlock(_component_Command, {
                        key: source.command,
                        item: source,
                        standalone: "",
                        onClick: $event => ($options.selectSource(source.command))
                      }, null, 8 /* PROPS */, ["item", "onClick"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "section-title" }, "Skills", -1 /* HOISTED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.skill_groups, (group) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: group.category
                      }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "skill-group",
                          onClick: $event => ($options.toggleGroup(group.category))
                        }, [
                          _createVNode(_component_Icon, {
                            icon: group.icon,
                            size: "2rem",
                            stroke: "var(--gray-700)",
                            "stroke-width": "1"
                          }, null, 8 /* PROPS */, ["icon"]),
                          _createElementVNode("span", null, _toDisplayString(group.title), 1 /* TEXT */),
                          _createVNode(_component_Icon, {
                            icon: $data.open_groups[group.category] ? 'chevron-up' : 'chevron-down',
                            size: "1.8rem",
                            stroke: "var(--gray-500)",
                            "stroke-width": "1"
                          }, null, 8 /* PROPS */, ["icon"])
                        ], 8 /* PROPS */, _hoisted_3),
                        _createVNode(_component_Collapse, {
                          open: !!$data.open_groups[group.category]
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (skill) => {
                              return (_openBlock(), _createBlock(_component_Command, {
                                key: skill.command,
                                item: skill,
                                standalone: "",
                                onClick: $event => ($options.selectSkill(skill.command))
                              }, null, 8 /* PROPS */, ["item", "onClick"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["open"])
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 128 /* KEYED_FRAGMENT */)),
                    ($props.skills.length && $props.sources.length)
                      ? (_openBlock(), _createBlock(_component_Divider, {
                          key: 0,
                          m: "0.8rem"
                        }))
                      : _createCommentVNode("v-if", true),
                    ($props.sources.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Sources"))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filtered_sources, (source) => {
                      return (_openBlock(), _createBlock(_component_Command, {
                        key: source.command,
                        item: source,
                        standalone: "",
                        onClick: $event => ($options.selectSource(source.command))
                      }, null, 8 /* PROPS */, ["item", "onClick"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 64 /* STABLE_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["bar-x-offset"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}